import { useEffect, useState } from "react";
import { BsBuilding } from "react-icons/bs";
import Count from "../../../components/shared/Count";
import fetchAllContacts from "../../../services/fetchAllContacts";
import CustomerPanel from "./CustomerPanel";
export default function CustomerWidget() {
  const [showDetails, setShowDetails] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const handleFetchCustomers = async () => {
    setLoading(true);
    const data = await fetchAllContacts();
    setCustomers(data?.payload);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchCustomers();
  }, []);

  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-3 bg-white border border-gray-300 rounded-lg mx-2 hover:bg-red-100 cursor-pointer mb-2 sm:mb-0">
      <button
        onClick={() => setShowDetails(true)}
        className="py-2 px-3 flex flex-row items-center "
      >
        <div className="bg-gray-100 h-16 w-16 rounded-full text-white flex justify-center items-center">
          <BsBuilding size={28} color="#E50000" />
        </div>
        <div className="flex flex-col ml-2 justify-center">
          <div className="text-xs text-blue-900 font-bold uppercase">
            Total Customers
          </div>
          <div className="flex  justify-between items-center text-sm">
            <div className="rounded-sm text-black text-3xl font-bold">
              <Count isLoading={isLoading} count={customers.length} />
            </div>
          </div>
        </div>
      </button>

      <CustomerPanel
        isVisible={showDetails}
        setShowDetails={setShowDetails}
        customers={customers}
      />
    </div>
  );
}
